import { Injector } from '@angular/core';
import { createCloseScrollStrategy, ScrollStrategy } from '@angular/cdk/overlay';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
  MAT_DATE_LOCALE,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  provideNativeDateAdapter,
  RippleGlobalOptions
} from '@angular/material/core';
import { ConfigurationService } from '@tdwb/core';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
};

function matSelectScrollStrategyFactory(injector: Injector): () => ScrollStrategy {
  return (): ScrollStrategy => createCloseScrollStrategy(injector);
}

function matDateLocaleFactory(config: ConfigurationService): string {
  return config.getProperty('locale') === 'fr_CA' ? 'fr' : 'en';
}

export const WEBBROKER_MATERIAL_PROVIDERS = [
  {
    provide: MAT_SELECT_SCROLL_STRATEGY,
    deps: [Injector],
    useFactory: matSelectScrollStrategyFactory
  },
  {
    provide: MAT_DATE_LOCALE,
    useFactory: matDateLocaleFactory,
    deps: [ConfigurationService]
  },
  provideNativeDateAdapter(),
  {
    provide: MAT_RIPPLE_GLOBAL_OPTIONS,
    useValue: globalRippleConfig
  },
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: { hideRequiredMarker: true }
  }
];
